module.exports = __webpack_public_path__ + "img/qrcode.21f88d08.png";